export default "__VITE_ASSET__428bfc4a__"